'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Carousel = require('../../carousel/main/jsx/Carousel');

var _Carousel2 = _interopRequireDefault(_Carousel);

var _genericTabs = require('../../generic-tabs');

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _breakpoints = require('../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'steps-intent';

var ctaMap = {
  primary: 'blue',
  secondary: 'outline-blue'
};

var handleIntentChange = function handleIntentChange(e, props) {
  var elem = e.target;
  var fptiValue = elem[elem.value].innerText;
  props.fireTracking('StepsInt-DropDown-' + fptiValue);
};

var renderHatchText = function renderHatchText(hatchText) {
  if (hatchText && hatchText.text) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__hatch-text text-xs-center' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};
var renderFilteredProps = function renderFilteredProps(props) {
  var content = props.content,
      config = props.config,
      className = props.className;
  var headline = content.headline,
      intents = content.intents;


  var filteredProps = {
    content: {
      headline: headline,
      list: {
        content: {
          items: [{}]
        }
      },
      content: [{}]
    },
    config: config,
    className: className
  };

  intents.forEach(function (element, index) {
    filteredProps.content.list.content.items[index] = element.option;
    filteredProps.content.content[index] = element;
  });

  return filteredProps;
};

var StepsIntent = function (_React$Component) {
  _inherits(StepsIntent, _React$Component);

  function StepsIntent(props) {
    _classCallCheck(this, StepsIntent);

    var _this = _possibleConstructorReturn(this, (StepsIntent.__proto__ || Object.getPrototypeOf(StepsIntent)).call(this, props));

    _this.state = {
      isMobile: false,
      showImages: false
    };
    _this.handleResize = _this.handleResize.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.handleIntentChange = handleIntentChange.bind(_this);
    // adding references in case this component is extended
    _this.handleIntentChange = handleIntentChange;
    _this.renderHatchText = renderHatchText;
    _this.renderFilteredProps = renderFilteredProps;
    return _this;
  }

  _createClass(StepsIntent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      var sectionElement = this.organismRef ? this.organismRef.sectionElement : null;
      var domRect = sectionElement && sectionElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      window.removeEventListener('scroll', this.handleScroll);
      this.enableImages();
    }
  }, {
    key: 'handleResize',
    value: function handleResize(e) {
      // TODO: Explore different solution to trigger resize
      // inside an iFrame; We don't need this event
      // param; it's only for page-builder
      var newWindowWidth = e && e.iFrameWidth || window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (newWindowWidth < _breakpoints2.default.medium) {
        if (!this.state.isMobile) {
          this.setState({
            isMobile: true
          });
        }
      } else if (this.state.isMobile) {
        this.setState({
          isMobile: false
        });
      }
    }
  }, {
    key: 'renderStepsImage',
    value: function renderStepsImage(image) {
      var showArrows = this.props.config.showArrows;

      if (image) {
        return _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + '__image-wrapper text-xs-center' },
          showArrows && _react2.default.createElement('span', { className: ORGANISM_NAME + '__arrow' }),
          _react2.default.createElement('img', { alt: '', src: image.src })
        );
      }
      return null;
    }
  }, {
    key: 'renderIntents',
    value: function renderIntents(intents) {
      var _this2 = this;

      var showImages = this.state.showImages;

      if (intents) {
        var stepsObj = intents.steps.map(function (elem, idx) {
          return _react2.default.createElement(
            'div',
            {
              key: idx,
              className: 'col-md-4 col-sm-12 ' + ORGANISM_NAME + '__step'
            },
            showImages ? _this2.renderStepsImage(elem.image) : null,
            _react2.default.createElement(
              'span',
              { className: ORGANISM_NAME + '__circle text-xs-center' },
              idx + 1
            ),
            _react2.default.createElement(
              'div',
              { className: ORGANISM_NAME + '__content' },
              _react2.default.createElement(
                'p',
                { className: ORGANISM_NAME + '__text' },
                htmlToReactParser.parse(elem.paragraph.text)
              )
            )
          );
        });

        if (this.state.isMobile) {
          var options = {
            className: ORGANISM_NAME,
            continuous: false
          };

          return _react2.default.createElement(
            _Carousel2.default,
            {
              key: this.state.intent,
              className: ORGANISM_NAME + '__carousel',
              options: options,
              content: this.props.content.carousel,
              trackId: this.props.config.trackId
            },
            stepsObj
          );
        }
        return stepsObj;
      }
      return null;
    }
  }, {
    key: 'renderCta',
    value: function renderCta(cta) {
      var ctaType = this.props.config.ctaType || '';
      if (cta && ctaMap[ctaType] && cta.text) {
        var buttonClass = ORGANISM_NAME + '__btn';
        var color = ctaMap[ctaType];
        var targetValue = cta.target || '_self';
        return _react2.default.createElement(
          _button2.default,
          {
            href: cta.href,
            id: cta.id,
            className: buttonClass,
            fpti: 'StepsInt-Int' + (parseInt(this.state.intent, 10) + 1) + '-PrmryCTA-' + (cta.fpti || cta.text),
            color: color,
            target: targetValue
          },
          cta.text
        );
      }
      return null;
    }
  }, {
    key: 'renderBelowSteps',
    value: function renderBelowSteps(intents) {
      var cta = intents.cta,
          hatchText = intents.hatchText;

      if (cta || hatchText) {
        return _react2.default.createElement(
          'div',
          { className: 'row ' + ORGANISM_NAME + '__cta-container' },
          this.renderCta(cta),
          renderHatchText(hatchText)
        );
      }
      return null;
    }
  }, {
    key: 'renderContent',
    value: function renderContent(content) {
      var _this3 = this;

      if (content) {
        return content.map(function (properties, idx) {
          return _react2.default.createElement(
            'div',
            { key: idx },
            _react2.default.createElement(
              'div',
              { className: 'row ' + ORGANISM_NAME + '__container' },
              _this3.renderIntents(properties)
            ),
            _this3.renderBelowSteps(properties)
          );
        });
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var filteredProps = renderFilteredProps(this.props);

      var config = filteredProps.config,
          className = filteredProps.className;


      var stepsIntentClasses = (0, _classnames2.default)(ORGANISM_NAME, ORGANISM_NAME + '--show-images', config.theme, className);

      return _react2.default.createElement(
        _genericTabs.GenericTabs,
        _extends({
          className: stepsIntentClasses
        }, filteredProps, {
          ref: function ref(c) {
            _this4.organismRef = c;
          }
        }),
        this.renderContent(filteredProps.content.content)
      );
    }
  }]);

  return StepsIntent;
}(_react2.default.Component);

exports.default = StepsIntent;


StepsIntent.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light']).isRequired,
    ctaType: _propTypes2.default.oneOf(['primary', 'secondary', 'no-cta']),
    showArrows: _propTypes2.default.bool,
    trackId: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    carousel: _propTypes2.default.shape({
      goToSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      goToNextSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      goToPreviousSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      })
    }),
    intents: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      option: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired,
      steps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        image: _propTypes2.default.shape({
          src: _propTypes2.default.string.isRequired
        }).isRequired,
        paragraph: _propTypes2.default.shape({
          text: _propTypes2.default.string.isRequired
        }).isRequired
      })).isRequired,
      cta: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired,
        href: _propTypes2.default.string.isRequired,
        id: _propTypes2.default.string,
        fpti: _propTypes2.default.string,
        target: _propTypes2.default.oneOf(['_self', '_blank'])
      }),
      hatchText: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      })
    })).isRequired
  }),
  className: _propTypes2.default.string,
  fireTracking: _propTypes2.default.func
};

StepsIntent.defaultProps = {
  config: {
    id: '',
    theme: 'theme-background-color-white',
    showArrows: true,
    ctaType: 'primary',
    trackId: 'StepsInt'
  },
  content: {
    headline: {
      text: '40 characters maximum'
    },
    carousel: {
      goToSlide: {
        text: 'Go to slide'
      },
      goToNextSlide: {
        text: 'Go to next slide'
      },
      goToPreviousSlide: {
        text: 'Go to previous slide'
      }
    },
    intents: [{
      option: {
        text: '17 characters max(tab-1)'
      },
      steps: [{
        image: {
          src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step1.png'
        },
        paragraph: {
          text: '32 characters per line maximum; make steps of consistent length'
        }
      }, {
        image: {
          src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step2.png'
        },
        paragraph: {
          text: '32 characters per line maximum; make steps of consistent length'
        }
      }, {
        image: {
          src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step3.png'
        },
        paragraph: {
          text: '32 characters per line maximum; make steps of consistent length'
        }
      }],
      cta: {
        text: '29 characters maximum',
        href: '#',
        id: '',
        target: '_self'
      },
      hatchText: {
        text: '34 characters maximum per line'
      }
    }, {
      option: {
        text: '17 characters max(tab-2)'
      },
      steps: [{
        image: {
          src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step1.png'
        },
        paragraph: {
          text: '32 characters per line maximum; make steps of consistent length'
        }
      }, {
        image: {
          src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step2.png'
        },
        paragraph: {
          text: '32 characters per line maximum; make steps of consistent length'
        }
      }, {
        image: {
          src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step3.png'
        },
        paragraph: {
          text: '32 characters per line maximum; make steps of consistent length'
        }
      }],
      cta: {
        text: '29 characters maximum',
        href: '#',
        id: '',
        target: '_self'
      },
      hatchText: {
        text: '34 characters maximum per line'
      }
    }]
  },
  className: '',
  fireTracking: function fireTracking() {}
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/steps-intent/jsx/StepsIntent.js
// module id = 1150
// module chunks = 4